import { api } from './client';

/** Ruteo de notificaciones (Bloque 3). Prefijo: /api/notification-routing */

export type TriggerAudience = 'interno' | 'cliente' | 'tecnico';

export interface TriggerMeta {
  key: string;
  label: string;
  audience: TriggerAudience;
}

export type RolNumero = 'dueno' | 'secretaria' | 'encargado_tecnicos' | 'otro';

export interface NumeroAviso {
  id: string;
  nombre: string;
  rol: RolNumero;
  phone: string;
}

export interface RouteConfig {
  enabled: boolean;
  numeroIds: string[];
}

export interface RoutingConfig {
  numeros: NumeroAviso[];
  rutas: Record<string, RouteConfig>;
}

export interface CanalEmisor {
  id: string;
  name: string;
  status: string;
  /** Número propio del canal si el socket está vivo (best-effort). */
  phone: string | null;
}

export interface RoutingState {
  config: RoutingConfig;
  catalog: TriggerMeta[];
  canales: CanalEmisor[];
}

export const getRouting = () => api.get<RoutingState>('/api/notification-routing');

export const saveRouting = (config: RoutingConfig) =>
  api.put<RoutingConfig>('/api/notification-routing', config);
